import { Coordinates } from "src/api/generated/common/address/coordinates.ts";

export const defaultProximity: Coordinates = {
	lng: 24.945831,
	lat: 60.192059,
}; // Helsinki, Finland

export function toGoogleLatLng(coords: Coordinates): google.maps.LatLngLiteral {
	return {
		lat: coords.lat,
		lng: coords.lng,
	};
}

export function fitMapToCoords(
	map: google.maps.Map,
	coords: Coordinates[],
	padding: google.maps.Padding = { top: 100, right: 100, bottom: 100, left: 100 },
) {
	if (coords.length === 0) return;

	if (coords.length === 1) {
		map.setCenter(toGoogleLatLng(coords[0]!));
		map.setZoom(14);
		return;
	}

	const bounds = new google.maps.LatLngBounds();
	coords.forEach((coords) => {
		bounds.extend(toGoogleLatLng(coords));
	});
	map.fitBounds(bounds, padding);
}

